<!-- Export Confirmation Email Modal -->
<ng-template
  #exportModal
  let-modal
  class="modal fade blur export-modal"
  id="exportModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-content">
    @if (tableDetails.exportType === 'directExport') {
      <ng-container>
        <div class="modal-header">
          <h5>Download Ready</h5>
          <button
            type="button"
            class="btn-close"
            (click)="close(exportModal)"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="form">
            <p class="subtext">Your download will begin shortly!</p>
          </div>
        </div>
      </ng-container>
    }
    @if (tableDetails.exportType === 'emailExport') {
      <ng-container>
        <div class="modal-header">
          <h5>This might take a minute!</h5>
          <button
            type="button"
            class="btn-close"
            (click)="close(exportModal)"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="form">
            <p class="subtext">
              Your Export may take a minute to generate.<br />
              Once it is ready, the generated file will be sent to your email:<br />
              <span id="exportEmailDefault">{{ tableDetails.userEmailId }}</span
              ><br />
            </p>
          </div>
        </div>
      </ng-container>
    }
    <div class="modal-footer">
      <a
        role="button"
        class="button button-pink"
        (click)="close(exportModal)"
        tabindex="0"
        (keydown.enter)="close(exportModal)"
        aria-label="Close"
        >Close</a
      >
    </div>
  </div>
</ng-template>
@if (this.tabs && this.tabs.length > 0) {
  <div class="tabs-container">
    <ul>
      @for (tab of this.tabs; track tab) {
        <li
          class="tab active"
          [ngClass]="{ active: tab.id === this.activeTabId }"
          [class.disabled]="isLoader()"
          tabindex="0"
          (click)="handleTabClick(tab.id)"
        >
          {{ tab.label }}
        </li>
      }
    </ul>
  </div>
}

<div class="table-container">
  <div class="table-header">
    <h5>{{ tableDetails.tableTitle }}</h5>
    <div class="table-header-right">
      @if (this.tableDetails.countTitle && this.tableDetails.countTitle !== '') {
        <span class="data-count">
          {{ this.tableDetails.countTitle }}: {{ this.tableDetails.countNumber?.() }}
        </span>
      }
      @if (this.tableDetails.showExport) {
        <div ngbDropdown class="dropdown" tabindex="0">
          <button
            class="button button-green"
            ngbDropdownToggle
            [ngClass]="{ disabled: isLoader() }"
          >
            Export
          </button>
          <ul class="dropdown-menu bg-white border-0 shadow export-menu" ngbDropdownMenu>
            <li
              ngbDropdownItem
              (click)="handleExportOptionClick('csv', exportModal)"
              (keydown.enter)="handleExportOptionClick('csv', exportModal)"
            >
              .CSV
            </li>
            <li
              ngbDropdownItem
              (click)="handleExportOptionClick('pdf', exportModal)"
              (keydown.enter)="handleExportOptionClick('pdf', exportModal)"
            >
              .PDF
            </li>
          </ul>
        </div>
      }
    </div>
  </div>
  <!-- Loader -->
  @if (isLoader()) {
    <app-loader></app-loader>
  }
  <div class="table-wrap">
    <table [id]="this.tableId" #userTable>
      <thead>
        <tr>
          @for (column of columns; track column) {
            <th
              [ngClass]="{ sortable: column.isSortable, actions: column.name === 'Actions' }"
              #sortLastLoggedIn
              (click)="sortTypeToggle(column)"
              tabindex="0"
              (keydown.enter)="sortTypeToggle(column)"
            >
              <span class="col-title">{{ column.name }}</span>
              @if (column.isSortable) {
                <div class="table-sort-icon">
                  @if (column.sortState === 'none') {
                    <img
                      src="../../../../../../../../assets/images/unfold_more.svg"
                      alt="unfold_more"
                      class="sort-icon"
                    />
                  }
                  @if (column.sortState === 'desc') {
                    <img
                      src="../../../../../../../../assets/images/keyboard_arrow_up.svg"
                      alt="keyboard_arrow_up"
                      class="sort-icon"
                    />
                  }
                  @if (column.sortState === 'asc') {
                    <img
                      src="../../../../../../../../assets/images/keyboard_arrow_down.svg"
                      alt="keyboard_arrow_down"
                      class="sort-icon"
                    />
                  }
                </div>
              }
            </th>
          }
        </tr>
      </thead>
      @if (!isLoader() && tableDetails.tableData) {
        <tbody>
          @for (row of tableDetails.tableData; track row.id) {
            <ng-container>
              <tr
                (click)="tableDetails.allowRowClick ? selectRow(row) : null"
                tabindex="0"
                (keydown.enter)="tableDetails.allowRowClick ? selectRow(row) : null"
                [ngClass]="{
                  clickable: tableDetails.allowRowClick,
                  'non-clickable': !tableDetails.allowRowClick,
                  'loading-row': row.loading,
                }"
              >
                @for (column of columns; track column) {
                  <td
                    [ngClass]="{
                      actions: column.display === 'actions',
                      'concealed-toggle': column.display === 'concealed',
                    }"
                    [attr.title]="
                      (column.display !== 'actions' &&
                        column.display !== 'concealed' &&
                        column.display !== 'template') ||
                      (column.display === 'concealed' && isRevealed(column, row['id']))
                        ? column.display === 'date'
                          ? (row[column.responseKey] | customFormatDate: 'datetime')
                          : row[column.responseKey]
                        : null
                    "
                  >
                    @if (column.display === 'template') {
                      <ng-container>
                        <ng-container
                          *ngTemplateOutlet="
                            column.cellTemplate;
                            context: {
                              $implicit: row,
                              row: row,
                              column: column,
                              value: row[column.responseKey],
                              isNested: false,
                            }
                          "
                        ></ng-container>
                      </ng-container>
                    }

                    @if (
                      column.display === 'normal' ||
                      (column.display === 'concealed' && isRevealed(column, row['id'])) ||
                      row[column.responseKey] === '--'
                    ) {
                      <span
                        [ngClass]="{ 'concealed-span': column.display === 'concealed' }"
                        class="value"
                      >
                        {{ row[column.responseKey] }}
                      </span>
                    }

                    @if (
                      column.display === 'concealed' &&
                      !isRevealed(column, row['id']) &&
                      row[column.responseKey] !== '--'
                    ) {
                      <span class="concealed-span"> **************** </span>
                    }

                    @if (column.display === 'amount') {
                      <span> ${{ row[column.responseKey] | customFormatCurrency }} </span>
                    }

                    @if (column.display === 'date') {
                      <span>
                        {{ row[column.responseKey] | customFormatDate: 'datetime' }}
                      </span>
                    }
                    @if (column.display === 'dateOnly') {
                      <span>
                        {{ row[column.responseKey] | customFormatDate }}
                      </span>
                    }

                    @if (column.display === 'status') {
                      <span
                        (click)="
                          row[column.responseKey] === 'Refunded' ||
                          row[column.responseKey] === 'Refund Attempted'
                            ? handleNestedRowClick(row, $event)
                            : null
                        "
                        [ngClass]="[row.expanded ? 'expanded' : '']"
                      >
                        <div
                          [ngClass]="getStatusClass(row[column.responseKey], column)"
                          class="status-button"
                        >
                          <div class="status-circle"></div>
                          <span class="status-text">{{ row[column.responseKey] }}</span>
                        </div>
                        @if (
                          column.hasNestedRow &&
                          (row[column.responseKey] === 'Refunded' ||
                            row[column.responseKey] ===
                              'Refund
                Attempted')
                        ) {
                          <img
                            class="expand-row"
                            src="../../../../../../../../assets/images/arrow_circle_down.svg"
                            alt=""
                          />
                        }
                      </span>
                    }

                    @if (column.display === 'method') {
                      <span class="method" [ngClass]="getMethodClass(row[column.responseKey])">
                        <img
                          [src]="
                            '/assets/images/' + getMethodClass(row[column.responseKey]) + '.svg'
                          "
                          alt=""
                        />
                        <span class="cap-ellipsis">{{ row[column.responseKey] }} </span>
                      </span>
                    }

                    @if (column.display === 'actions') {
                      <div
                        ngbDropdown
                        class="dropdown"
                        (click)="$event.stopPropagation()"
                        tabindex="0"
                        (keydown.enter)="$event.stopPropagation()"
                      >
                        <div class="ellipsis" ngbDropdownToggle>
                          <span class="material-symbols-outlined"> &#xe5d3; </span>
                        </div>
                        <ul class="dropdown-menu bg-white border-0 shadow" ngbDropdownMenu>
                          @for (operation of row.operations; track operation) {
                            <li
                              ngbDropdownItem
                              (click)="onActionMenuClick(operation, row); $event.stopPropagation()"
                              title="{{ operation.value }}"
                              tabindex="0"
                              (keydown.enter)="
                                onActionMenuClick(operation, row); $event.stopPropagation()
                              "
                            >
                              {{ operation.value }}
                            </li>
                          }
                        </ul>
                      </div>
                    }

                    @if (column.display === 'concealed' && row[column.responseKey] !== '--') {
                      <span
                        class="material-symbols-outlined eye-icon"
                        (click)="toggleConcealContent(column, row['id'])"
                        tabindex="0"
                        (keydown.enter)="toggleConcealContent(column, row['id'])"
                      >
                        {{ isRevealed(column, row.id) ? 'visibility_off' : 'visibility' }}
                      </span>
                    }

                    @if (
                      column?.displayOptions?.includes('addCopyButton') &&
                      row[column.responseKey] !== '--'
                    ) {
                      <span
                        class="material-symbols-outlined copy-icon"
                        (click)="
                          allyCommonService.copyValueToClipboard(row[column.responseKey]);
                          $event.stopPropagation()
                        "
                        tabindex="0"
                        (keydown.enter)="
                          allyCommonService.copyValueToClipboard(row[column.responseKey]);
                          $event.stopPropagation()
                        "
                        >&#xe14d;</span
                      >
                    }
                  </td>
                }
              </tr>
              @if (row.expanded) {
                <ng-container class="nested-row-container">
                  @for (nestedRow of row.nestedRows; track nestedRow) {
                    <tr
                      (click)="tableDetails.allowRowClick ? selectRow(nestedRow) : null"
                      tabindex="0"
                      (keydown.enter)="tableDetails.allowRowClick ? selectRow(nestedRow) : null"
                      [ngClass]="{
                        clickable: tableDetails.allowRowClick,
                        'non-clickable': !tableDetails.allowRowClick,
                      }"
                      class="nested-row"
                    >
                      @for (column of columns; track column) {
                        <td
                          [ngClass]="{
                            actions: column.display === 'actions',
                            'concealed-toggle': column.display === 'concealed',
                          }"
                          [attr.title]="
                            (column.display !== 'actions' && column.display !== 'concealed') ||
                            (column.display === 'concealed' && isRevealed(column, nestedRow['id']))
                              ? nestedRow[column.responseKey]
                              : null
                          "
                        >
                          @if (
                            column.display === 'normal' ||
                            (column.display === 'concealed' &&
                              isRevealed(column, nestedRow['id'])) ||
                            nestedRow[column.responseKey] === '--'
                          ) {
                            <span
                              [ngClass]="{ 'concealed-span': column.display === 'concealed' }"
                              class="value"
                            >
                              {{ nestedRow[column.responseKey] }}
                            </span>
                          }

                          @if (
                            column.display === 'concealed' &&
                            !isRevealed(column, nestedRow['id']) &&
                            nestedRow[column.responseKey] !== '--'
                          ) {
                            <span class="concealed-span"> **************** </span>
                          }

                          @if (column.display === 'date') {
                            <span>
                              {{ nestedRow[column.responseKey] | customFormatDate: 'datetime' }}
                            </span>
                          }

                          @if (column.display === 'status') {
                            <span>
                              <div
                                [ngClass]="getStatusClass(nestedRow[column.responseKey], column)"
                                class="status-button"
                              >
                                <div class="status-circle"></div>
                                <span class="status-text">{{ nestedRow[column.responseKey] }}</span>
                              </div>
                            </span>
                          }

                          @if (column.display === 'method') {
                            <span
                              class="method"
                              [ngClass]="getMethodClass(nestedRow[column.responseKey])"
                            >
                              <img
                                [src]="
                                  '/assets/images/' +
                                  getMethodClass(nestedRow[column.responseKey]) +
                                  '.svg'
                                "
                                alt=""
                              />
                              {{ nestedRow[column.responseKey] }}
                            </span>
                          }

                          @if (column.display === 'actions') {
                            <div
                              ngbDropdown
                              class="dropdown"
                              (click)="$event.stopPropagation()"
                              tabindex="0"
                              (keydown.enter)="$event.stopPropagation()"
                            >
                              <div class="ellipsis" ngbDropdownToggle>
                                <span class="material-symbols-outlined"> &#xe5d3; </span>
                              </div>
                              <ul class="dropdown-menu bg-white border-0 shadow" ngbDropdownMenu>
                                @for (operation of nestedRow.operations; track operation) {
                                  <li
                                    ngbDropdownItem
                                    (click)="
                                      onActionMenuClick(operation, nestedRow);
                                      $event.stopPropagation()
                                    "
                                    title="{{ operation.value }}"
                                    tabindex="0"
                                    (keydown.enter)="
                                      onActionMenuClick(operation, nestedRow);
                                      $event.stopPropagation()
                                    "
                                  >
                                    {{ operation.value }}
                                  </li>
                                }
                              </ul>
                            </div>
                          }

                          @if (column.display === 'concealed' && row[column.responseKey] !== '--') {
                            <span
                              class="material-symbols-outlined eye-icon"
                              (click)="toggleConcealContent(column, nestedRow['id'])"
                              tabindex="0"
                              (keydown.enter)="toggleConcealContent(column, nestedRow['id'])"
                            >
                              {{
                                isRevealed(column, nestedRow.id) ? 'visibility_off' : 'visibility'
                              }}
                            </span>
                          }

                          @if (
                            column?.displayOptions?.includes('addCopyButton') &&
                            nestedRow[column.responseKey] !== '--'
                          ) {
                            <span
                              class="material-symbols-outlined copy-icon"
                              (click)="
                                allyCommonService.copyValueToClipboard(
                                  nestedRow[column.responseKey]
                                );
                                $event.stopPropagation()
                              "
                              tabindex="0"
                              (keydown.enter)="
                                allyCommonService.copyValueToClipboard(
                                  nestedRow[column.responseKey]
                                );
                                $event.stopPropagation()
                              "
                              >&#xe14d;</span
                            >
                          }
                        </td>
                      }
                    </tr>
                  }
                </ng-container>
              }
            </ng-container>
          }
        </tbody>
      }
    </table>
    @if (!isLoader() && (tableDetails.tableData?.length ?? 0) === 0) {
      <div class="no-results-container">
        <h3>No Results Found</h3>
      </div>
    }
  </div>
</div>

@if (tableDetails.tableData && tableDetails.tableData.length > 0) {
  <div class="page-container" [ngClass]="{ disabled: isLoader() }">
    @if (tableDetails.pager.totalPages > 1) {
      <div class="page-choices" aria-label="Page navigation">
        @if (tableDetails.pager.currentPage !== 1 && tableDetails.pager.currentPage !== 2) {
          <a
            [ngClass]="{ disabled: tableDetails.pager.currentPage === 1 }"
            (click)="updatePage(1)"
            tabindex="0"
            (keydown.enter)="updatePage(1)"
            id="firstPage"
            class="page-arrow disabled"
            aria-label="First"
            ><span class="material-symbols-outlined">&#Xeac3;</span></a
          >
        }
        <a
          [ngClass]="{ disabled: pager.currentPage === 1 }"
          (click)="updatePage(pager.currentPage - 1)"
          tabindex="0"
          (keydown.enter)="updatePage(pager.currentPage - 1)"
          id="lastPage"
          class="page-arrow disabled"
          aria-label="Previous"
          ><span class="material-symbols-outlined">&#xe5cb;</span></a
        >
        @for (page of tableDetails.pager.pages; track page) {
          <a
            id="currentPage"
            class="active"
            [ngClass]="{
              active: tableDetails.pager.currentPage === page,
              disabled: tableDetails.pager.currentPage === page,
            }"
            (click)="updatePage(page)"
            tabindex="0"
            (keydown.enter)="updatePage(page)"
            >{{ page }}</a
          >
        }
        <a
          id="nextPage"
          class="page-arrow"
          [ngClass]="{ disabled: tableDetails.pager.currentPage === tableDetails.pager.totalPages }"
          (click)="updatePage(tableDetails.pager.currentPage + 1)"
          tabindex="0"
          (keydown.enter)="updatePage(tableDetails.pager.currentPage + 1)"
          aria-label="Next"
          ><span class="material-symbols-outlined">&#xe5cc;</span></a
        >
        @if (
          tableDetails.pager.currentPage !== tableDetails.pager.totalPages &&
          tableDetails.pager.currentPage !== tableDetails.pager.totalPages - 1
        ) {
          <a id="lastPage" class="page-arrow" aria-label="Next"
            ><span
              class="material-symbols-outlined"
              [ngClass]="{
                disabled: tableDetails.pager.currentPage === tableDetails.pager.totalPages,
              }"
              (click)="updatePage(tableDetails.pager.totalPages)"
              (keydown.enter)="updatePage(tableDetails.pager.totalPages)"
              >&#Xeac9;</span
            ></a
          >
        }
      </div>
    }
    Items per Page:
    <div class="position-relative">
      <select
        [(ngModel)]="defaultItemPerPage"
        #pageCount
        (change)="onPageCountChange(pageCount.value)"
        [ngModelOptions]="{ standalone: true }"
        name="maxPerPage"
        id="maxPerPage"
        class="per-page position-relative bg-white rounded-3 border-0 px-3 py-2"
      >
        @for (item of itemPerPage; track item) {
          <option>
            {{ item.value }}
          </option>
        }
      </select>
      <i class="bi bi-caret-down-fill position-absolute custom-expand-icon"></i>
    </div>
  </div>
}
